/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type RadarSignalSnapshotResponse = {
    signal_id: string;
    code: string;
    name: string;
    status: RadarSignalSnapshotResponse.status;
    latest_price: (number | null);
    previous_close: (number | null);
    today_return: (number | null);
    top5_avg_return: (number | null);
    price_threshold_return: (number | null);
    price_pass: boolean;
    today_cum_volume: (number | null);
    history_avg_cum_volume: (number | null);
    volume_ratio: (number | null);
    volume_pass: boolean;
    triggered_at: (string | null);
    buyability: RadarSignalSnapshotResponse.buyability;
    pass_reasons?: Array<string>;
    warning_reasons?: Array<string>;
    block_reasons?: Array<string>;
};
export namespace RadarSignalSnapshotResponse {
    export enum status {
        WATCHING = 'watching',
        NEAR = 'near',
        TRIGGERED = 'triggered',
        COOLING = 'cooling',
        IGNORED = 'ignored',
        ORDERED = 'ordered',
    }
    export enum buyability {
        PASS = 'pass',
        WARNING = 'warning',
        BLOCKED = 'blocked',
    }
}

